/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ExecutionsPage = () => {
  document.title = `Dashboard | LeadZLab`;
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/dashboard", { replace: true });
  }, [navigate]);

  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <p className="text-slate-600">Redirecting to dashboard…</p>
    </div>
  );
};

export default ExecutionsPage;
